<script lang="ts">
  type Step = {
    number: string;
    title: string;
    description: string;
  };

  const steps: Step[] = [
    {
      number: '1',
      title: 'Import Your Transactions',
      description: 'Drag and drop CSV files from your bank. Auto-detection handles the rest. Organize by family member using folder structure.',
    },
    {
      number: '2',
      title: 'Smart Categorization',
      description: 'Transactions auto-match using fuzzy matching and rules. Optionally use AI (Claude/GPT) for bulk categorizing what remains. Manual overrides when needed. Clean merchant names automatically.',
    },
    {
      number: '3',
      title: 'Track & Budget',
      description: 'See spending trends, set budgets with rollover, detect recurring bills. Beautiful analytics show where your money goes.',
    },
  ];
</script>

<section class="section how-it-works-section">
  <div class="container">
    <div class="section-header">
      <h2>How It Works</h2>
      <p>Get started in minutes, no account required</p>
    </div>
    <div class="steps">
      {#each steps as step, index}
        <div class="step">
          <div class="step-number">{step.number}</div>
          <div class="step-content">
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        </div>
        {#if index < steps.length - 1}
          <div class="step-arrow">→</div>
        {/if}
      {/each}
    </div>
  </div>
</section>

<style>
  .how-it-works-section {
    background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
  }

  .section-header {
    text-align: center;
    max-width: 700px;
    margin: 0 auto var(--spacing-2xl);
  }

  .section-header h2 {
    font-size: var(--font-size-3xl);
    margin-bottom: var(--spacing-sm);
  }

  .section-header p {
    font-size: var(--font-size-lg);
    color: var(--color-text-secondary);
    margin: 0;
  }

  .steps {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-lg);
    max-width: 1000px;
    margin: 0 auto;
  }

  .step {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .step-number {
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 50%;
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-bold);
    margin-bottom: var(--spacing-md);
    box-shadow: var(--shadow-md);
  }

  .step-number {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  }

  .step-content h3 {
    font-size: var(--font-size-lg);
    margin-bottom: var(--spacing-xs);
  }

  .step-content p {
    color: var(--color-text-secondary);
    line-height: var(--line-height-normal);
    font-size: var(--font-size-sm);
    margin: 0;
  }

  .step-arrow {
    font-size: var(--font-size-2xl);
    color: var(--color-text-muted);
    flex-shrink: 0;
  }

  @media (max-width: 968px) {
    .steps {
      flex-direction: column;
      gap: var(--spacing-2xl);
    }

    .step-arrow {
      transform: rotate(90deg);
    }
  }
</style>
